<script>
import ToggleSwitchInput from './ToggleSwitchInput.vue';

export default {
  name: 'ToggleSwitch',
  components: { ToggleSwitchInput },
  props: {
    name: {
      type: String,
      required: true,
    },
    option1: {
      type: String,
      required: true,
    },
    option1Label: {
      type: String,
      required: true,
    },
    option2: {
      type: String,
      required: true,
    },
    option2Label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data: function() {
    return {
      uid: 0,
      newValue: this.value,
    };
  },
  watch: {
    value(value) {
      this.newValue = value;
    },
    newValue(value) {
      this.$emit('input', value);
    },
  },
  mounted() {
    this.uid = `${this._uid}`;
  },
  methods: {
    id: function(name) {
      return name.replace(/[\W]/, '') + this.uid;
    },
  },
};
</script>
<template>
  <div class="toggle-switch__container">
    <ToggleSwitchInput
      :id="id(option1)"
      :name="name"
      :native-value="option1"
      v-model="newValue"
    />
    <label
      :for="id(option1)"
      :class="{ active: newValue === option1, 'toggle-switch__track': true }"
    >
      {{ option1Label }}
    </label>

    <ToggleSwitchInput
      :id="id(option2)"
      :name="name"
      :native-value="option2"
      v-model="newValue"
    />
    <label
      :for="id(option2)"
      :class="{ active: newValue === option2, 'toggle-switch__switch': true }"
    >
      {{ option2Label }}
    </label>
  </div>
</template>
